import styled from 'styled-components';

export const DesktopWrapper = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.palette.white};
  outline: 1px solid ${({ theme }) => theme.palette.gray87};
  border-radius: 8px;
  padding: 8px;
  &:hover button {
    background: ${({ theme }) => theme.palette.tomato};
    color: ${({ theme }) => theme.palette.white};
    box-shadow: 0 10px 30px 0 rgba(255, 65, 57, 0.5);
  }
  position: relative;
`;

export const TourDetailsDesktop = styled.div`
  margin-left: 8px;
  width: auto;
`;

export const BodyContainer = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 230px 1fr;
  width: 100%;
`;

export const TourDetailsItemDesktop = styled.div`
  & > div {
    align-items: center;
  }
`;
export const ZoneWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  width: max-content;
`;
export const ListingTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const TourNameWrapperDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 9px;
`;
export const BadgeWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

export const TourTitleDesktop = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 630px;
  color: ${({ theme }) => theme.palette.NL800} !important;
`;

export const TourBoardTypeWrapper = styled.div``;

export const TourListingItemDetailsDesktop = styled.div`
  position: relative;
  align-self: end;
`;

export const TourDivider = styled.span`
  display: block;
  width: 36px;
  height: 6px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.palette.coral};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 19px;
    height: 3px;
    margin: 15px 0 10px 0;
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
`;
export const DetailWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
`;

export const WorldLogoWrapperDesktop = styled.div`
  height: 32px;
`;
export const DiscountWrapperDesktop = styled.div`
  margin-left: auto;
  height: 25px;
`;

export const PriceInfoWrapperDesktop = styled.div`
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 100%;
`;

export const PriceSubLabel = styled.span`
  display: block;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.NL500};
  text-align: right;
`;

export const DesktopButtonWrapper = styled.div`
  button {
    width: 102px;
    height: 40px;
    box-shadow: none;
    background: transparent;
    border-radius: 8px;
    border: solid 1px ${({ theme }) => theme.palette.BR500};
    color: ${({ theme }) => theme.palette.BR500};
    font-weight: normal;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
  }
`;

export const ShareWrapperDesktop = styled.div`
  right: 16px;
  top: -2px;
  display: flex;
  gap: 5px;
  align-items: start;
`;

export const ListingCardBodyWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
  height: calc(100% - 58px);
`;

export const DesktopBottomContainer = styled.div`
  display: flex;
  width: 100%;
  border-top: solid 1px ${({ theme }) => theme.palette.NL30};
  height: 34px;
  margin-top: 6px;
  padding-top: 6px;
`;
export const TourPromotions = styled.div`
  width: 100%;
`;
export const PromotionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;
export const BottomWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 6px;
`;

export const PromotionBottomContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 6px;
`;
